export const constrain = (value, min, max) =>
  Math.min(Math.max(value, min), max);



// WEBPACK FOOTER //
// ./src/utils/math.js